import { motion } from 'framer-motion';
import { useParams, Link } from 'react-router-dom';
import { posts } from '../data';
import { Calendar, ArrowLeft, Tag } from 'lucide-react';

export default function PostDetail() {
  const { id } = useParams<{ id: string }>();
  const post = posts.find((p) => p.id === id);

  if (!post) {
    return (
      <div className="min-h-screen pt-24 pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl font-bold text-white mb-4">文章未找到</h1>
          <p className="text-gray-400 mb-8">抱歉，您访问的文章不存在。</p>
          <Link to="/posts" className="btn-primary inline-flex items-center">
            <ArrowLeft size={18} className="mr-2" />
            返回文章列表
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-24 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <motion.article
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Back Button */}
          <Link
            to="/posts"
            className="inline-flex items-center text-gray-400 hover:text-pink-400 transition-colors mb-8"
          >
            <ArrowLeft size={18} className="mr-2" />
            返回文章列表
          </Link>

          {/* Header */}
          <header className="mb-8">
            <div className="flex items-center space-x-4 text-sm text-pink-300/70 mb-4">
              <span className="flex items-center">
                <Calendar size={14} className="mr-1" />
                {post.date}
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
              {post.title}
            </h1>
            <div className="flex flex-wrap gap-2">
              {post.tags.map((tag) => (
                <span
                  key={tag}
                  className="inline-flex items-center px-3 py-1 text-sm bg-pink-500/20 text-pink-300 rounded-full border border-pink-500/30"
                >
                  <Tag size={12} className="mr-1" />
                  {tag}
                </span>
              ))}
            </div>
          </header>

          {/* Content */}
          <div className="glass rounded-xl p-8">
            <div className="prose prose-invert max-w-none">
              {post.content.split('\n\n').map((paragraph, index) => {
                if (paragraph.startsWith('## ')) {
                  return (
                    <h2 key={index} className="text-2xl font-bold text-pink-300 mt-8 mb-4">
                      {paragraph.replace('## ', '')}
                    </h2>
                  );
                }
                if (paragraph.startsWith('- ')) {
                  return (
                    <ul key={index} className="list-disc list-inside space-y-2 text-gray-300 my-4">
                      {paragraph.split('\n').map((item, i) => (
                        <li key={i}>{item.replace('- ', '')}</li>
                      ))}
                    </ul>
                  );
                }
                return (
                  <p key={index} className="text-gray-300 leading-relaxed mb-4">
                    {paragraph}
                  </p>
                );
              })}
            </div>
          </div>
        </motion.article>
      </div>
    </div>
  );
}
